import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";
import type { Calendar } from "../../Calendars/Models/Domain";
import type { CalendarApi } from "../../Calendars/Models/Api";

import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";

import { camel } from "@/Utils/Camelize";
import { snake } from "@/Utils/Snakelize";

const CalendarTransformer: TransformerExtended<Calendar, CalendarApi> = {
  ...DefaultTransformerGenerator<Calendar, CalendarApi>(),

  toDomain(input: CalendarApi): Calendar {
    return camel(input);
  },

  toApi(input: Calendar): CalendarApi {
    return snake(input);
  },
};

export type CalendarTransformerType = TransformerExtended<Calendar, CalendarApi>;

export default CalendarTransformer;
